import * as _ from "lodash";
import { hasWorkSpacesPermission } from "../../../services/Workspaces.service";
import BaseWorkspaceApiService from "../../../services/workspaces/baseWorkspaceApiService";
import type { IWsConfig } from "../config/stateToWsConfigMap";
import { getWsConfigFromState } from "../config/stateToWsConfigMap";

// @ts-ignore FIXME: strict migration - Variable 'similarweb' implicitly has an 'any' type — legacy global injected on window, no type available
declare const similarweb;
export function HasWorkspaceTrialPermission(): boolean {
    const proWindow: any = window;
    return (
        proWindow.similarweb.settings.components.Workspaces.resources.WorkspaceType === "Trial" ||
        proWindow.similarweb.settings.components.Workspaces.resources.WorkspaceType === "MarketingTrial" ||
        (_.isArray(proWindow.similarweb.settings.components.Workspaces.resources.WorkspaceType) &&
            _.find(
                proWindow.similarweb.settings.components.Workspaces.resources.WorkspaceType,
                (workspace: string) => workspace === "Trial" || workspace === "MarketingTrial",
            ) !== undefined)
    );
}

export async function isDomainInWorkspace(domain: string) {
    if (hasWorkSpacesPermission()) {
        // enough to check here, because it is method from base class and checks for every workspace type
        const baseApiService = new BaseWorkspaceApiService();
        const lists = await baseApiService.getTrackingStatus(domain);
        if (lists.length === 0) {
            return { hasLists: false };
        }
        return {
            hasLists: true,
            isTracked: lists.every(({ isTracked }) => isTracked),
        };
    }
    return { hasLists: false };
}

function shouldLockModule(AvaliabilityMode: string) {
    return /hidden|locked|hook/i.test(AvaliabilityMode);
}

function applySubItemsPermissions(subItems: FixmeType[] = []) {
    return subItems.map((subItem) => {
        const { wsComponent: wsCmpName } = (getWsConfigFromState({ name: subItem.state }, subItem.tab) ||
            {}) as IWsConfig;
        // @ts-ignore FIXME: strict migration - Type 'undefined' cannot be used as an index type — IWsConfig.wsComponent may be undefined, legacy code assumes it resolves and guards on the lookup result below
        const wsComponent = similarweb.settings.components[wsCmpName];
        if (wsComponent && wsComponent.resources && wsComponent.resources.AvaliabilityMode) {
            return {
                ...subItem,
                lockIcon: shouldLockModule(wsComponent.resources.AvaliabilityMode),
            };
        }
        return subItem;
    });
}

export function applyNavItemPermissions(item: FixmeType) {
    if (hasWorkSpacesPermission() && !HasWorkspaceTrialPermission()) {
        const subItemsWithPermissions = applySubItemsPermissions(item.subItems);
        if (subItemsWithPermissions.length) {
            return {
                ...item,
                subItems: subItemsWithPermissions,
            };
        }
        return item;
    }
    return item;
}

export const isValidURL = (str: string) => {
    const pattern = new RegExp(
        "^((ft|htt)ps?:\\/\\/)?" + // protocol
            "((([a-z\\d]([a-z\\d-]*[a-z\\d])?)\\.)+[a-z]{2,}|" + // domain name and extension
            "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
            "(\\:\\d+)?" + // port
            "(\\/[-a-z\\d%@_.~+&:]*)*" + // path
            "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
            "(\\#[-a-z\\d_]*)?$",
        "i",
    ); // fragment locator
    return !!pattern.test(str);
};

export const safeParse = (str: string, defaultValue?: any) => {
    try {
        return JSON.parse(str);
    } catch (e) {
        return defaultValue;
    }
};
